/**
 * Authentication provider types supported by the platform.
 * Note: Keep in sync with AuthProviderType in frontend/libs/configs/src/consts.ts
 */
export enum AuthProvider {
    Auth0 = 'auth0',
    SelfManaged = 'self-managed',
}
